import styled from 'styled-components';

export const StyledDivider = styled.hr`
  margin: 0;
`;
